import moment from 'moment';
import { React, withRouter, PT, WithData, fetchApi } from '@gasbuddy/react';
import { Dimmer, Loader, Table, Segment, Input, Checkbox, Button } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';
import { CreateOfferModal } from './CreateOfferModal';

class BaseButtonMerchants extends React.Component {
  state = {
    column: 'partner_name',
    direction: 'ascending',
  }

  sync = () => {
    this.setState({ syncing: true }, async () => {
      await fetchApi({
        url: '/loyalty/button-merchants/sync',
        body: {},
      });
      const { fetch: fetchFn } = this.props;
      this.setState({ syncing: false }, fetchFn);
    });
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  makeOffer(merchantId) {
    this.setState({ open: true, merchantId });
  }

  render() {
    const { column, direction, search, showWithOffer, syncing, open, merchantId } = this.state;
    const { data, loading } = this.props;
    const { pending } = this.state;

    const dir = direction === 'ascending' ? 1 : -1;
    const merchants = data ? (data.merchants || [])
      .filter((entry) => {
        if (!showWithOffer && Number(entry.offers) !== 0) {
          return false;
        }
        if (!search) {
          return true;
        }
        if (search.length < 4) {
          return entry.name?.toLowerCase().startsWith(search.toLowerCase())
            || entry.internal_name?.toLowerCase().startsWith(search.toLowerCase());
        }
        return entry.name?.toLowerCase().includes(search.toLowerCase())
          || entry.internal_name?.toLowerCase().includes(search.toLowerCase());
      })
      .sort((a, b) => {
        switch (column) {
          case 'id':
            return (a.merchant_offer_id - b.merchant_offer_id) * dir;
          case 'offers':
            return ((a.offers - b.offers) || (a.internal_name.localeCompare(b.internal_name))) * dir;
          case 'internal_name':
            return (a.internal_name.localeCompare(b.internal_name)) * dir;
          case 'provider_identifier':
            return (a.provider_identifier.localeCompare(b.provider_identifier)) * dir;
          case 'display_name':
            return (a.display_name.localeCompare(b.display_name)) * dir;
          case 'created_at':
            return (moment(a.created_at).valueOf() - moment(b.created_at).valueOf()) * dir;
          default:
            return 0;
        }
      }) : [];

    return (
      <Auth forRoles={[Role.Superuser, Role.GasBackCampaigns]}>
        <Nav>
          <div>
            <Button
              onClick={this.sync}
              content="Sync Merchants"
              loading={syncing}
              color="green"
              icon="plus"
              labelPosition="left"
              floated="right"
            />
            <h1>Button Merchants</h1>
            {open && <CreateOfferModal open providers={data?.providers} merchants={data?.merchants} merchantId={merchantId} />}
            <Dimmer.Dimmable as={Segment} dimmed={loading || pending}>
              <Dimmer active={loading || pending}>
                <Loader />
              </Dimmer>
              <Table sortable striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan="6">
                      <Input icon="search" placeholder="Search..." onChange={(e, { value }) => this.setState({ search: value })} />
                      <Checkbox
                        style={{ marginLeft: 20 }}
                        checked={showWithOffer}
                        onChange={() => this.setState({ showWithOffer: !showWithOffer })}
                        label="Show merchants with offers"
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell sorted={column === 'id' && direction} width={1} onClick={this.handleSort('id')}>GB Id</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'provider_identifier' && direction} width={3} onClick={this.handleSort('provider_identifier')}>Button Id</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'created_at' && direction} width={2} onClick={this.handleSort('created_at')}>Created</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'internal_name' && direction} onClick={this.handleSort('internal_name')}>Merchant Key</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'display_name' && direction} onClick={this.handleSort('display_name')}>Merchant Name</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'offers' && direction} width={1} onClick={this.handleSort('offers')}>Offer Count</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {merchants.map(d => (
                    <Table.Row
                      key={d.merchant_id}
                      onClick={() => this.makeOffer(d.merchant_id)}
                    >
                      <Table.Cell>{d.merchant_id}</Table.Cell>
                      <Table.Cell>{d.provider_identifier}</Table.Cell>
                      <Table.Cell textAlign="center">{moment(d.created_at).format('MM/DD/YYYY HH:MM:ss')}</Table.Cell>
                      <Table.Cell>{d.internal_name}</Table.Cell>
                      <Table.Cell>{d.display_name}</Table.Cell>
                      <Table.Cell>{d.offers}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseButtonMerchants.propTypes = {
  fetch: PT.func.isRequired,
  data: PT.shape({
    merchants: PT.arrayOf(PT.shape({
      name: PT.string,
    })),
  }),
  loading: PT.bool,
};

BaseButtonMerchants.defaultProps = { loading: false, data: null };

export default withRouter(() => (
  <WithData url="/loyalty/button-merchants">
    <BaseButtonMerchants />
  </WithData>
));
